/*
 * @Date: 2021-09-27 16:47:47
 * @Author: Jeason
 * @LastEditors: Jeason
 * @LastEditTime: 2021-09-27 16:47:50
 * @Description: 项目中共用接口
 * @FilePath: \maintenancef:\sass_web\maintenance_expert\src\api\common.js
 */
import encryptServer from '@/request/encryptRequest';
export default {
  getQinNiuToken (params) {
    return encryptServer.post('/xiaozi-xmo/wireless/saas/base/getUploadToken', params);
  },
  // 保存页面访问记录
  savePageAccessRecord (params) {
    return encryptServer.post('/xiaozi-xmo/wireless/saas/pageAccessRecord/save', params);
  },
};
